import xhr from "xhr";

export default async function getAfiliate(data) {
  const response = await xhr(
    `/affiliates?sort[0]=id:asc&populate=deep,2&pagination[page]=1&pagination[pageSize]=100`
  );

  return response.data.data;
}
